<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class Logo extends Vue {}
</script>

<template>
    <img alt="Logo Neo DTx" src="/logo.png" />
</template>
